module.exports = __webpack_public_path__ + "img/2025-11-17c_8.44af8aff.jpg";